import { render, staticRenderFns } from "./SubmitTips.vue?vue&type=template&id=73f56b67&"
import script from "./SubmitTips.vue?vue&type=script&lang=js&"
export * from "./SubmitTips.vue?vue&type=script&lang=js&"
import style0 from "./SubmitTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports